import React, {useState, useCallback} from 'react';
import {setResampleMaster} from 'actions/index.js';
import SamplesPerNote from 'components/dropdowns/SamplesPerNote.js';

export default function ResampleConfigComponent(props) {
    const [isSampling, setIsSampling] = useState(props.sequencerEngine.autoResampleMode);

    const onClickSampleSynth = useCallback(() => {
        let sequencerEngine = props.sequencerEngine;
        if (isSampling) {
            sequencerEngine.autoResampleMode = false;
            sequencerEngine.store.dispatch(setResampleMaster(false));
            setIsSampling(false);
            return;
        }
        sequencerEngine.autoResampleMode = true;
        sequencerEngine.masterResampler.prepare();
        sequencerEngine.store.dispatch(setResampleMaster(true));
        setIsSampling(true);
    }, [isSampling, setIsSampling]);

    let className = isSampling ? "sample-synth-button sampling" : "sample-synth-button";

    return (
        <div className="resample-config">
          <div
            onClick={onClickSampleSynth}
            className={className}>
            {isSampling ? "Sample..." : "Sample"}
          </div>
          <SamplesPerNote sequencerEngine={props.sequencerEngine}/>
        </div>
    );
}
